import React from 'react';
import { FieldBox, Label, Input, Error } from './common';
import { IField } from './Form.interfaces';

export default function Field(props: IField) {
  const {
    label,
    type,
    name,
    placeholder,
    handleChange,
    onBlur,
    value,
    disabled,
    error,
    width,
    full,
    min,
    readonly,
  } = props;
  return (
    <FieldBox full={full} width={width}>
      {label && <Label name={name} label={label} width={width} />}
      <Input
        {...props}
        type={type}
        name={name}
        onChange={handleChange}
        onBlur={onBlur}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        error={!!error}
        dirty={!!value}
        min={min}
        readOnly={readonly}
      />
      {error && <Error>{error}</Error>}
    </FieldBox>
  );
}
